export default __webpack_public_path__ + "static/media/151-step-ladder.c356299a.png";